import { Enum, EnumClass } from 'osn-shared';
import { TrayFormViewModelType } from '../create-tray-screen/components/view-model-common/view-model-type';
import { PageItemType } from '../domain/page-item-type';

/* eslint-disable @typescript-eslint/naming-convention */
@Enum
export class TrayTypeBridge extends EnumClass {
  // CXB
  public static readonly OndemandCategoryTray = new TrayTypeBridge('category', 'OndemandCategoryTray', [
    TrayFormViewModelType.OndemandCategoryTray,
  ]);
  public static readonly OndemandBannerTray = new TrayTypeBridge('ondemand-banner', 'OndemandBannerTray', [
    TrayFormViewModelType.OndemandBannerTray,
  ]);
  public static readonly LandscapeTray = new TrayTypeBridge('landscape', 'LandscapeTray', [TrayFormViewModelType.LandscapeTray]);
  public static readonly Season = new TrayTypeBridge('season', 'SeasonTray', [TrayFormViewModelType.SeasonTray]);
  public static readonly SinglePhotoSeason = new TrayTypeBridge('single-photo-season', 'SinglePhotoSeasonTray', [
    TrayFormViewModelType.SinglePhotoSeasonTray,
  ]);
  public static readonly PortraitTray = new TrayTypeBridge('portrait', 'PortraitTray', [TrayFormViewModelType.PortraitTray]);
  public static readonly ExpandableTray = new TrayTypeBridge('expandable', 'ExpandableTray', [TrayFormViewModelType.ExpandableTray]);
  public static readonly TopTenTray = new TrayTypeBridge('top-ten', 'TopTenTray', [TrayFormViewModelType.TopTenTray]);
  public static readonly Collection = new TrayTypeBridge('collection', 'CollectionTray', [TrayFormViewModelType.CollectionTray]);
  public static readonly Genre = new TrayTypeBridge('genre', 'GenreTray', [TrayFormViewModelType.GenreTray]);
  public static readonly Studios = new TrayTypeBridge('studios', 'StudiosTray', [TrayFormViewModelType.StudiosTray]);
  public static readonly Hero = new TrayTypeBridge('hero', 'Hero', [TrayFormViewModelType.HeroTray]); // AXB-980
  public static readonly MarketingCta = new TrayTypeBridge('marketing-cta', 'MarketingCta', [TrayFormViewModelType.CTA]);
  public static readonly MarketingEmailCollector = new TrayTypeBridge('marketing-email-collector', 'MarketingEmailCollector', [
    TrayFormViewModelType.EMAIL,
  ]);
  public static readonly Recommendation = new TrayTypeBridge('recommendation', 'Recommendation', [
    TrayFormViewModelType.TopPicks,
    TrayFormViewModelType.Trending,
    TrayFormViewModelType.TrendingWithLayout,
    TrayFormViewModelType.BecauseYouWatched,
    TrayFormViewModelType.PeopleLikeYouWatch,
    TrayFormViewModelType.BecauseYouWatchGenreTray,
    TrayFormViewModelType.TrendingMovies,
    TrayFormViewModelType.TrendingSeries,
    TrayFormViewModelType.TopPicksMovies,
    TrayFormViewModelType.TopPicksSeries,
    TrayFormViewModelType.PeopleLikeYouWatchMovies,
    TrayFormViewModelType.PeopleLikeYouWatchSeries,
    TrayFormViewModelType.DontMiss,
    TrayFormViewModelType.TopPicksDownloadable,
    TrayFormViewModelType.TopPicksMoviesDownloadable,
    TrayFormViewModelType.TopPicksSeriesDownloadable,
    TrayFormViewModelType.PeopleLikeYouWatchDownloadable,
    TrayFormViewModelType.PeopleLikeYouWatchSeriesDownloadable,
    TrayFormViewModelType.PeopleLikeYouWatchMoviesDownloadable,
    TrayFormViewModelType.MostDownloadedMovies,
    TrayFormViewModelType.MostDownloadedSeries,
    TrayFormViewModelType.Editorial,
  ]);
  public static readonly MarketingVideoTray = new TrayTypeBridge('marketing-video', 'MarketingVideoTray', [
    TrayFormViewModelType.MarketingVideoTray,
  ]);
  public static readonly MarketingUsp = new TrayTypeBridge('marketing-usp', 'MarketingUsp', [TrayFormViewModelType.USP]);
  public static readonly MarketingStudio = new TrayTypeBridge('marketing-studio', 'MarketingStudio', [TrayFormViewModelType.STUDIO]);
  public static readonly MarketingTrending = new TrayTypeBridge('marketing-trending', 'MarketingTrending', [
    TrayFormViewModelType.TRENDING,
  ]);
  public static readonly MarketingKids = new TrayTypeBridge('marketing-kids', 'MarketingKids', [TrayFormViewModelType.KIDS]);
  public static readonly MarketingBarTray = new TrayTypeBridge('marketing-bar', 'MarketingBarTray', [
    TrayFormViewModelType.MarketingBarTray,
  ]);
  public static readonly MarketingHero = new TrayTypeBridge('marketing-hero', 'MarketingHero', [TrayFormViewModelType.MarketingHero]);
  public static readonly DetailedPageMarketingBanner = new TrayTypeBridge('detailed page marketing banner', 'DetailedPageMarketingBanner', [
    TrayFormViewModelType.DetailedPageMarketingBanner,
  ]);
  public static readonly RedeemGenericVoucherTray = new TrayTypeBridge('redeem-generic-voucher-tray', 'RedeemGenericVoucherTray', [
    TrayFormViewModelType.RedeemGenericVoucherTray,
  ]);
  public static readonly RedeemPartnerVoucherTray = new TrayTypeBridge('redeem-partner-voucher-tray', 'RedeemPartnerVoucherTray', [
    TrayFormViewModelType.RedeemPartnerVoucherTray, // AXB-948
  ]);
  public static readonly RedeemCtaTray = new TrayTypeBridge('redeem-cta-tray', 'RedeemCtaTray', [TrayFormViewModelType.RedeemCtaTray]);
  public static readonly RedeemUspTray = new TrayTypeBridge('redeem-usp-tray', 'RedeemUspTray', [TrayFormViewModelType.RedeemUspTray]);
  public static readonly FaqTray = new TrayTypeBridge('faq-tray', 'FaqTray', [TrayFormViewModelType.FaqTray]);
  public static readonly AppLandingMobileTray = new TrayTypeBridge('app-landing-mobile-tray', 'AppLandingPageTray', [
    TrayFormViewModelType.AppLandingMobileTray,
  ]);
  public static readonly AppLandingCotvTray = new TrayTypeBridge('app-landing-cotv-tray', 'AppLandingPageTray', [
    TrayFormViewModelType.AppLandingCotvTray,
  ]);
  public static readonly CollectionTray = new TrayTypeBridge('collection-tray', 'CollectionTray', [TrayFormViewModelType.CollectionTray]);
  public static readonly SeasonTray = new TrayTypeBridge('season-tray', 'SeasonTray', [TrayFormViewModelType.SeasonTray]);
  public static readonly SpotlightTray = new TrayTypeBridge('spotlight-tray', 'SpotlightTray', [TrayFormViewModelType.SpotlightTray]);
  public static readonly MarketingEmailBlocker = new TrayTypeBridge('marketing-email-blocker', 'MarketingEmailBlocker', [
    TrayFormViewModelType.MarketingEmailBlocker,
  ]);
  public static readonly DeviceModuleTray = new TrayTypeBridge('device-module-tray', 'DeviceModuleTray', [
    TrayFormViewModelType.DeviceModuleTray,
  ]);
  public static readonly MixedSearchTagTray = new TrayTypeBridge('mixed-search-tag-tray', 'MixedSearchTagTray', [
    TrayFormViewModelType.MixedSearchTagTray,
  ]);

  // UXB
  public static readonly Carousel = new TrayTypeBridge('carousel', 'Carousel', [
    TrayFormViewModelType.ContentTray,
    TrayFormViewModelType.CollectionTray,
  ]);
  // public static readonly Season = new TrayTypeBridge('season', 'Season', [TrayFormViewModelType.SeasonTray]);
  // public static readonly Generic = new TrayTypeBridge('generic', 'GenericCarousel', [TrayFormViewModelType.GenericTray]);

  public static readonly BuiltIn = new TrayTypeBridge('builtin', 'BuiltIn', [
    TrayFormViewModelType.MyFavouritesOnLiveTV, // AXB-71
    TrayFormViewModelType.LiveTVReminders, // AXB-84
    TrayFormViewModelType.ContinueWatchingTray, // AXB-79
    TrayFormViewModelType.MyListTray, // AXB-80
    TrayFormViewModelType.TVGuide, // AXB-78
    // CXB
    TrayFormViewModelType.WatchlistCarousel,
    TrayFormViewModelType.ContinueWatchingCarousel,
    TrayFormViewModelType.WatchlistOnDemandTray,
    TrayFormViewModelType.PrimeVideoRecommendationsTray,
    TrayFormViewModelType.ContinueWatchingOndemandTray,
    TrayFormViewModelType.RecentlyPurchasedTray,
    TrayFormViewModelType.ExpiringStoreContents,
  ]);
  public static readonly OtherApps = new TrayTypeBridge('other-apps', 'TitleImagePortraitTray', [
    TrayFormViewModelType.TitleImagePortraitTray,
  ]);
  public static readonly AppsAndGamesInstalledApps = new TrayTypeBridge('installed-apps', 'AppsAndGamesInstalledApps', [
    TrayFormViewModelType.AppsAndGames,
  ]);
  public static readonly AppsAndGamesRecommendedApps = new TrayTypeBridge('recommended-apps', 'AppsAndGamesRecommendedApps', [
    TrayFormViewModelType.AppsAndGames,
  ]);
  public static readonly TopTenOnOSNVodContent = new TrayTypeBridge('top-ten-vod-content', 'TopTenOnOSNPlusPosterArtTray', [
    TrayFormViewModelType.TopTenOnOSNPlusPosterArt, // AXB-82
  ]);
  public static readonly SearchTagsTray = new TrayTypeBridge('search-tags-tray', 'SearchTagsTray', [TrayFormViewModelType.SearchTagsTray]);
  public static readonly VodContent = new TrayTypeBridge('vod-content', 'StreamingContentTray', [
    TrayFormViewModelType.StreamingContentTray,
  ]);
  public static readonly CurrentlyOnTv = new TrayTypeBridge('currently-on-tv', 'CurrentlyOnTvTray', [
    TrayFormViewModelType.CurrentlyOnTvTray,
  ]);
  public static readonly TvChannelLogo = new TrayTypeBridge('tv-channel-logo', 'ChannelLogoTray', [TrayFormViewModelType.ChannelLogoTray]);
  public static readonly RecentlyWatchedTV = new TrayTypeBridge('recently-watched-tv', 'RecentlyWatchedTV', [
    TrayFormViewModelType.RecentlyWatchedTV,
  ]);
  public static readonly HeroSpotlight = new TrayTypeBridge('hero-spotlight', 'HeroSpotlight', [TrayFormViewModelType.HeroSpotlightTray]);
  //AXB-75
  public static TopTenOnLiveTv = new TrayTypeBridge('top-ten-on-live-tv', 'TopTenOnLiveTvTray', [TrayFormViewModelType.TopTenOnLiveTvTray]);
  //AXB-74
  public static ComingSoonLiveTv = new TrayTypeBridge('upcoming-live-tv', 'ComingSoonForLiveTvTray', [
    TrayFormViewModelType.ComingSoonForLiveTvTray,
  ]);
  public static CatchUp = new TrayTypeBridge('catch-up', 'CatchUpTray', [TrayFormViewModelType.CatchUpTray]);
  public static ChannelSpecificCatchUp = new TrayTypeBridge('channel-specific-catch-up', 'ChannelSpecificCatchUpTray', [
    TrayFormViewModelType.ChannelSpecificCatchUpTray,
  ]);

  // AXB-72
  public static FullscreenTray = new TrayTypeBridge('fullscreen', 'FullscreenTray', [TrayFormViewModelType.FullscreenTray]);
  //AXB-86
  public static BannersTrayWithCta = new TrayTypeBridge('banners-with-cta', 'BannersTrayWithCta', [
    TrayFormViewModelType.BannersTrayWithCta,
  ]);
  // AXB-87
  public static CarouselTray = new TrayTypeBridge('carousel-tray', 'CarouselTray', [TrayFormViewModelType.BannersThree]);
  // AXB-88
  public static CarouselBannerTray = new TrayTypeBridge('carousel-banner-tray', 'CarouselBannerTray', [
    TrayFormViewModelType.CarouselBannerTray,
  ]);
  //AXB-83
  public static UpcomingOnSpecificTvChannel = new TrayTypeBridge('upcoming-on-specific-tv-channel', 'UpcomingOnSpecificTvChannelTray', [
    TrayFormViewModelType.UpcomingOnSpecificTvChannelTray,
  ]);
  //AXB-194
  public static RecommendedChannelsTray = new TrayTypeBridge('recommended-channels-tray', 'RecommendedChannelsTray', [
    TrayFormViewModelType.RecommendedChannelsTray,
  ]);
  // AXB-330
  public static MarketingBannerTray = new TrayTypeBridge('marketing-banner', 'MarketingBannerTray', [
    TrayFormViewModelType.MarketingBannerTray,
  ]);

  private constructor(
    public readonly subRoute: string,
    public readonly pageItemType: PageItemType,
    public readonly trayFormTypes: TrayFormViewModelType[]
  ) {
    super();
  }

  public static parseFromPageItemType(pageItemType: PageItemType): TrayTypeBridge {
    return TrayTypeBridge.values<TrayTypeBridge>().find((it) => it.pageItemType === pageItemType);
  }

  public static parseFromRouteParam(routeParam: string): TrayTypeBridge {
    return TrayTypeBridge.values<TrayTypeBridge>().find((it) => it.subRoute === routeParam?.toLowerCase());
  }

  public static parseFromFormType(type: TrayFormViewModelType): TrayTypeBridge {
    return TrayTypeBridge.values<TrayTypeBridge>().find((it) => it.trayFormTypes.includes(type));
  }
}
